import '../fesd/fesd'
import '../../sass/investor/investor_stock.sass'
import { _dropdown } from '../includes/_dropdown.js'

$(function(){
  _dropdown.deskDropdown();
  _dropdown.all();
  $('[data-tab-container]').tab4();
  $('[data-scroll-content]').scrollbar();
  _common.faq('.faq-li', '.faq-ul');
});